let currentJoyfulApp: unknown = null

export function setCurrentJoyfulApp(app: unknown) {
  currentJoyfulApp = app
}

export function getCurrentJoyfulApp<TApp>() {
  if (currentJoyfulApp === null) {
    throw new Error('Joyful app runtime is not initialized')
  }

  // SAFETY: setCurrentJoyfulApp stores the app the caller later reads as TApp.
  return currentJoyfulApp as TApp
}
